// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const FortinetIcon = createSvgIcon(
  <svg id="logosandtypes_com" viewBox="0 0 150 150">
    <path d="M0 0h150v150H0V0z" fill="none" />
    <path
      d="M9.2 62.9h37.1v24.4H9.2V62.9zm47.4-34.6h36.5v24.4H56.6V28.3zm0 69.1h36.5v24.4H56.6V97.4zm46.6-34.5h37.3v24.4h-37.3V62.9zM24.5 28.3C16.7 30.3 10.7 39 9.2 50v2.8h37.1V28.3H24.5zM9.2 97.4v3c1.3 10.5 7 19 14.4 21.3h22.9V97.4H9.2zm131.2-44.8v-2.8c-1.4-10.9-7.5-19.6-15.3-21.7h-22v24.4h37.3v.1zm-14.3 69.3c7.2-2.5 12.9-10.8 14.3-21.3v-3h-37.3V122l23-.1z"
      fill="#ed3726"
    />
  </svg>,
  "Fortinet",
);
export default FortinetIcon;
